module.exports = __webpack_public_path__ + "img/bottomList3.b9f39d29.svg";